import styled, { css } from 'styled-components';
import { pxToRem } from '@anwb/style-utilities';
export const containerWrapperStyles = ({ theme, $withConstrainedWidth, $variant, }) => css `
	width: 100%;

	@media (min-width: ${pxToRem(theme.containerWidth.containerWidthMax)}) {
		${$withConstrainedWidth &&
    css `
			display: flex;
			justify-content: center;
		`}
	}

	${$variant === 'featured' &&
    css `
		background-color: ${theme.colors.extralight.bgSite};
	`}
`;
export const ContainerWrapper = styled.div `
	${containerWrapperStyles}
`;
export const containerContentStyles = ({ theme, $withConstrainedWidth, $withOuterSpacing, }) => css `
	flex: 1;

	${$withConstrainedWidth &&
    css `
		max-width: ${pxToRem(theme.containerWidth.containerWidthMax)};
	`}

	/* @TODO: check with UX */
	${$withOuterSpacing === true &&
    css `
		margin: ${pxToRem(theme.spacing['600'])} ${pxToRem(theme.spacing['200'])};
	`}

	${$withOuterSpacing === 'horizontal' &&
    css `
		margin: 0 ${pxToRem(theme.spacing['200'])};
	`}

	${$withOuterSpacing === 'vertical' &&
    css `
		margin: ${pxToRem(theme.spacing['600'])} 0;
	`}
`;
export const ContainerContent = styled.div `
	${containerContentStyles}
`;
//# sourceMappingURL=container.styled.js.map